import { lazy } from "react";
import { Navigate } from "react-router-dom";
import {
  BOLETAS_DETALLES_QR_URL,
  CURSOS_DETALLES_QR_URL,
  ESTUDIANTES_DETALLES_QR_URL,
  HOME_URL,
  LOGIN,
  RESET_PASSWORD,
  RESET_PASSWORD_CONFIRM,
  TRABAJADORES_DETALLES_QR_URL,
} from "../bases_url";

// Lazy imports
const SignInBasic = lazy(
  () => import("../../layouts/authentication/sign-in/basic")
);
const ResetPassword = lazy(
  () => import("../../layouts/authentication/reset-password/reset-password")
);
const NewPassword = lazy(
  () =>
    import(
      "../../layouts/authentication/reset-password-confirm/reset-password-confirm"
    )
);
const CursoDetallesQr = lazy(
  () =>
    import(
      "../../layouts/escuela/data-tables/cursos/components/curso_detalles_qr"
    )
);
const EstudianteDetallesQr = lazy(
  () => import("../../layouts/estudiantes/qr/estudiantes_info-qr")
);
const TrabajadoresDetallesQr = lazy(
  () => import("../../layouts/trabajadores/qr/trabajadores_info-qr")
);
const BoletasDetallesQr = lazy(
  () =>
    import(
      "../../layouts/escuela/data-tables/grupos/components/boletas_detalles_qr"
    )
);

export const publicRoutes = [
  {
    path: "*",
    element: <Navigate to={HOME_URL} />,
  },
  {
    path: LOGIN,
    element: <SignInBasic />,
  },
  {
    path: RESET_PASSWORD,
    element: <ResetPassword />,
  },
  {
    path: RESET_PASSWORD_CONFIRM,
    element: <NewPassword />,
  },
  {
    path: CURSOS_DETALLES_QR_URL,
    element: <CursoDetallesQr />,
  },
  {
    path: ESTUDIANTES_DETALLES_QR_URL,
    element: <EstudianteDetallesQr />,
  },
  {
    path: TRABAJADORES_DETALLES_QR_URL,
    element: <TrabajadoresDetallesQr />,
  },
  {
    path: BOLETAS_DETALLES_QR_URL,
    element: <BoletasDetallesQr />,
  },
];
